import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{attrs:{"no-gutters":""}},[_c(VCol,{attrs:{"cols":"12","sm":"4"}},[_c('bar-order-panel')],1),_c(VCol,{attrs:{"cols":"12","sm":"8"}},[_c('bar-product-gallery')],1),_c(VCol,{attrs:{"cols":"12"}},[_c('bar-order-submit',{on:{"confirmOrder":function($event){return _vm.$emit('confirmOrder')}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }